import React from 'react'
import { FormValueInput, FormValueMeta } from 'types'
import AnimBox from 'components/AnimBox'
import AvailabilityChip from 'components/AvailabilityChip'
import useStyles from './styles'

export interface IAvailabilityOptionsProps {
  input: FormValueInput<'available_now' | 'available_soon' | 'not_available'>
  meta: FormValueMeta // TODO: actually display errors and use this
}

function AvailabilityOptions(props: IAvailabilityOptionsProps) {
  const { classes } = useStyles()
  const { input: { value, onChange } } = props

  const options = ['available_now', 'available_soon', 'not_available'].map((availability, index) => (
    <AnimBox grow delay={index * 200} key={availability}>
      <div className={classes.availabilityChip}>
        <AvailabilityChip
          availability={availability}
          current={value}
          onClick={() => onChange(availability)}
          key={availability}
        />
      </div>
    </AnimBox>
  ))

  return (
    <div className={classes.availabilityOptions}>
      {options}
    </div>
  )
}

export default React.memo(AvailabilityOptions)
